import classNames from 'classnames';
import { differenceInCalendarDays } from 'date-fns';
import React from 'react';
import { useAnimatedWidth } from '../common/useAnimateWidth';
import { localDateStringWithWeekdayAndYear } from '../common/client-utils-commonjs';
import { useTranslation } from 'react-i18next';
import '../../less/grading-progress.less';
export const GradingProgress = ({ gradingCompleted, gradingProgress, testId, small = false, dateTargets, label }) => {
    const progress = gradingProgress || 0;
    const animatedStyle = useAnimatedWidth(progress);
    const { i18n } = useTranslation();
    const dates = dateTargets ? Object.values(dateTargets) : [];
    const completed = gradingCompleted || gradingProgress === 100;
    label = label || `${progress} %`;
    const lang = i18n.language;
    return (React.createElement("span", { className: classNames('grading-progress', {
            small,
            completed,
            'with-dates': dates.length > 0
        }) },
        React.createElement("span", { className: "progress-text", "data-testid": testId ? `${testId}-text` : undefined }, label),
        React.createElement("span", { className: "progress-bg" },
            React.createElement("div", { className: "progress-fg-container" },
                React.createElement("span", { className: classNames('progress-fg', {
                        'has-progress': !!gradingProgress
                    }), style: animatedStyle })), dates === null || dates === void 0 ? void 0 :
            dates.map((t, index) => {
                const deadlineIsPassedOrToday = t.date
                    ? differenceInCalendarDays(t.date, new Date()) <= 0 && progress < t.target * 100
                    : false;
                return (React.createElement("span", { key: [t.date, index].join('-'), className: classNames('intermediate-mark', {
                        'hidden-mark': t.target === 1
                    }), style: { left: `calc(${t.target * 100}% - 2px)` } },
                    React.createElement("div", { className: classNames('date', {
                            red: deadlineIsPassedOrToday,
                            green: progress >= t.target * 100
                        }), "data-testid": "pregrading-deadline-date" },
                        localDateStringWithWeekdayAndYear({ date: t.date, lang }),
                        t.date && progress >= t.target * 100 && React.createElement("span", { className: "reached" }, "\u2714"))));
            }))));
};
//# sourceMappingURL=grading-progress.js.map